(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('TabDataController', TabDataController);

    TabDataController.$inject = ['$rootScope', '$scope', '$state', 'TabData', 'Principal', '$timeout', '$stickyState'];

    function TabDataController ($rootScope, $scope, $state, TabData, Principal, $timeout, $stickyState) {
        var vm = this;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.activeTabIndex = 0;

        $scope.initialise = function () {
            $scope.tabData = TabData.initialiseTabs();
            if ($scope.tabData.length > 1) {
                vm.activeTabIndex = TabData.findIndex($scope.tabData, $scope.tabData[1]);
            }
        };

        $scope.initialise();

        vm.closeAll = function () {
            var dashboardTab = getDashboardTab();
            $state.go(dashboardTab.route);
            $timeout(function() {
               vm.activateTabIndex = 0;
               $timeout(function() {
                   iterateThroughTabs();
                   $timeout(function() {
                       $scope.tabData = [dashboardTab];
                   });
               });
            });
        };

        vm.closeAllExceptSelected = function() {
            var index = vm.activeTabIndex;
            var dashboardTab = getDashboardTab();
            var selectedTab = angular.copy($scope.tabData[index]);
            iterateThroughTabs( selectedTab.route );
            $timeout( function(){
                $scope.tabData = [dashboardTab, selectedTab];
                $timeout(function() {
                    $state.go(selectedTab.route);
                    $timeout(function () {
                        vm.activeTabIndex = 1;
                    });
                });
            });
        };

        function iterateThroughTabs( route ) {
            angular.forEach($scope.tabData, function( value, key ) {
                var myRoute = $scope.tabData[key].route;
                if( route == null ) {
                    $timeout( function() {
                        verifyRemoveStickyState( myRoute )
                    });
                } else {
                    if( route != myRoute ) {
                        $timeout( function() {
                            verifyRemoveStickyState( myRoute )
                        });
                    }
                }
            });
        }

        function getDashboardTab() {
            return {
                heading: 'Dashboard',
                route: 'home',
                id: '',
                param: {id: ''}
            };
        }

        vm.close = function (index) {
            var closedTabRoute = null;
            if ($scope.tabData[index].route !== undefined) {
                closedTabRoute = $scope.tabData[index].route;
            }
            $scope.tabData.splice(index, 1);
            $timeout(function () {
                var todo = TabData.stateAfterCloseTab($scope.tabData, index);
                $state.go(todo.route);
                $timeout(function () {
                    vm.activeTabIndex = todo.index;
                    if (closedTabRoute !== null) {
                        verifyRemoveStickyState(closedTabRoute);
                    }
                });
            });
        };

        vm.go = function (tabData) {
            if (("" === tabData.id) && (!TabData.checkParams(tabData))) {
                $state.go(tabData.route);
            } else {
                var params = {};
                params.id = tabData.id;
                if (TabData.checkParams(tabData)) {
                    var keys = Object.keys(tabData.param);
                    for (var k in keys) {
                        if (keys[k] !== "id") {
                            params[keys[k]] = tabData.param[keys[k]];
                        } else { //id is a reserved key
                            params["paramId"] = tabData.param[keys[k]];
                        }
                    }
                }
                $state.go(tabData.route, params);
            }
        };

        $scope.$on('handleBroadcast', function (event, args) {
            if (!TabData.ifDuplicate($scope.tabData, args)) {
                $scope.tabData.push(TabData.addTabs(args));
                $timeout(function () {
                    vm.activeTabIndex = ($scope.tabData.length - 1);
                });
            } else {
                var params = {};
                if (args.param && args.param.activeTab) {
                    params.activeTab = args.param.activeTab;
                }
                $state.go(args.route, params);
                $timeout(function () {
                    vm.activeTabIndex = TabData.findIndex($scope.tabData, args);
                });
            }
        });

        function verifyRemoveStickyState(myRoute) {
            var newState = ".new";
            var editState = ".edit";
            var importState = ".import";
            if (myRoute.indexOf(newState) > 0 || myRoute.indexOf(editState) > 0 || myRoute.indexOf(importState) > 0) {
                // remove closed tabs with route that contains .new & .edit
                $stickyState.reset(myRoute);
            } //else do nothing
        }
    }
})();
